class Coupon {
  constructor() {
    this.init();
  }

  init() {
    this.id = undefined;
    this.code = undefined;
    this.coupon_type = undefined;
    this.provider_id = undefined;
    this.amount = undefined;
    this.percentage = undefined;
    this.auto_apply = undefined;
    this.start_date = undefined;
    this.end_date = undefined;
    this.max_usage = undefined;
    this.consumed = undefined;
    this.subsidies = undefined;
    this.questions = undefined;
  }

  copy() {
    const cp = new Coupon();

    cp.id = this.id ? this.id.toString() : undefined;
    cp.code = this.code;
    cp.coupon_type = this.coupon_type;
    cp.provider_id = this.provider_id ? this.provider_id.toString() : undefined;
    cp.amount = this.amount;
    cp.percentage = this.percentage;
    cp.auto_apply = this.auto_apply;
    cp.start_date = this.start_date ? new Date(this.start_date) : undefined;
    cp.end_date = this.end_date ? new Date(this.end_date) : undefined;
    cp.max_usage = this.max_usage;
    cp.consumed = this.consumed;
    cp.subsidies = this.subsidies ? [...this.subsidies] : undefined;
    cp.questions = this.questions ? [...this.questions] : undefined;
    return cp;
  }

  buildFromJSON(obj) {
    this.init();
    if (obj) {
      this.id = obj.id ? obj.id.toString() : undefined;
      this.code = obj.code ? obj.code : undefined;
      this.coupon_type = obj.coupon_type ? obj.coupon_type : undefined;
      this.provider_id = obj.provider_id ? obj.provider_id.toString() : undefined;
      this.amount = (obj.amount !== undefined) && (obj.amount !== null) ? obj.amount : undefined;
      this.percentage = (obj.percentage !== undefined) ? obj.percentage : undefined;
      this.auto_apply = (obj.auto_apply !== undefined) && (obj.auto_apply !== null) ? obj.auto_apply : undefined;
      this.start_date = obj.start_date ? new Date(obj.start_date) : undefined;
      this.end_date = obj.end_date ? new Date(obj.end_date) : undefined;
      this.max_usage = (obj.max_usage !== undefined) && (obj.max_usage !== null) ? obj.max_usage : undefined;
      this.consumed = (obj.consumed !== undefined) && (obj.consumed !== null) ? obj.consumed : undefined;
      this.subsidies = obj.subsidies ? [...obj.subsidies] : undefined;
      this.questions = obj.questions ? [...obj.questions] : undefined;
    }
  }

  toString() {
    let result = this.id ? this.id : '';
    return result;
  }

  getId() {
    return this.id;
  }

  setId(id) {
    this.id = id ? id.toString() : undefined;
  }

  getProviderId() {
    return this.provider_id;
  }

  setProviderId(provider_id) {
    this.provider_id = provider_id ? provider_id.toString() : undefined;
  }
  
  getCode() {
    return this.code;
  }

  setCode(code) {
    this.code = code ? code : undefined;
  }

  getCouponType() {
    return this.coupon_type;
  }

  setCouponType(coupon_type) {
    this.coupon_type = coupon_type;
  }
  
  getAmount() {
    return this.amount;
  }

  setAmount(amount) {
    this.amount = (amount !== undefined) && (amount != null) ? amount : undefined;
  }

  getPercentage() {
    return this.percentage;
  }

  setPercentage(percentage) {
    this.percentage = (percentage !== undefined) ? percentage : undefined;
  }

  getAutoApply() {
    return this.auto_apply;
  }

  setAutoApply(auto_apply) {
    this.auto_apply = (auto_apply !== undefined) && (auto_apply !== null) ? auto_apply : undefined;
  }

  getStartDate() {
    return this.start_date;
  }

  setStartDate(start_date) {
    this.start_date = start_date ? new Date(start_date) : undefined;
  }

  getEndDate() {
    return this.end_date;
  }

  setEndDate(end_date) {
    this.end_date = end_date ? new Date(end_date) : undefined;
  }

  getMaxUsage() {
    return this.max_usage;
  }

  setMaxUsage(max_usage) {
    this.max_usage = (max_usage !== undefined) && (max_usage !== null) ? max_usage : undefined;
  }

  getConsumed() {
    return this.consumed;
  }

  setConsumed(consumed) {
    this.consumed = (consumed !== undefined) && (consumed !== null) ? consumed : undefined;
  }

  getSubsidies() {
    return this.subsidies;
  }

  setSubsidies(subsidies) {
    this.subsidies = subsidies ? [...subsidies] : undefined;
  }

  getQuestions() {
    return this.questions;
  }

  setQuestions(questions) {
    this.questions = questions ? [...questions] : undefined;
  }
}

module.exports = Coupon;
